import PropTypes from 'prop-types';

import { Content, Inner } from './interval-tariffication.styled';
import { IntervalSimple } from './blocks/interval-simple/interval-simple';

export const IntervalTariffication = (props) => {
  const { color, display, ...rest } = props;

  return (
    <Content color={color} style={{ display: display ? 'block' : 'none' }}>
      <Inner>
        <IntervalSimple {...rest} />
      </Inner>
    </Content>
  );
};

IntervalTariffication.propTypes = {
  selectedZone: PropTypes.any,
  show: PropTypes.bool,
  disabled: PropTypes.bool,
  newIndividual: PropTypes.bool,
};
